// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/History.css */
.history-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin-bottom: 20px;
  color: #333;
  font-size: 28px;
}

.refresh-button {
  background-color: #4a90e2;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 14px;
}

.refresh-button:hover {
  background-color: #357bd8;
}

.refresh-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.loading {
  text-align: center;
  margin: 40px 0;
  font-size: 18px;
  color: #666;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.no-jobs {
  text-align: center;
  margin: 40px 0;
  font-size: 18px;
  color: #666;
}

/* Table styles */
.jobs-table-container {
  width: 100%;
  overflow-x: auto;
}

.jobs-table {
  width: 100%;
  border-collapse: collapse;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 6px;
  overflow: hidden;
}

.jobs-table th,
.jobs-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.jobs-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.jobs-table tbody tr:last-child td {
  border-bottom: none;
}

.jobs-table tbody tr:hover {
  background-color: #f9f9f9;
}

.job-id {
  font-family: monospace;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status {
  font-weight: 500;
  text-transform: capitalize;
}

.status-completed {
  color: #28a745;
}

.status-pending {
  color: #ffc107;
}

.status-failed {
  color: #dc3545;
}

.status-processing {
  color: #17a2b8;
}

.actions {
  text-align: center;
}

.view-button {
  display: inline-block;
  background-color: #4a90e2;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 13px;
  transition: background-color 0.2s;
}

.view-button:hover {
  background-color: #357bd8;
  text-decoration: none;
  color: white;
}

/* Expand/collapse button */
.expand-button {
  background: none;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  line-height: 22px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  color: #555;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expand-button:hover {
  background-color: #f0f0f0;
}

/* Expanded details row */
.expanded-details {
  background-color: #f9f9f9;
}

.expanded-details td {
  padding: 20px;
}

/* Clip details container and sections */
.clip-details-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.clip-section {
  margin-bottom: 10px;
}

.clip-section h3 {
  margin-top: 0;
  margin-bottom: 12px;
  color: #333;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

/* Clip list */
.clip-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
}

.clip-item {
  background-color: white;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.clip-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.clip-name {
  font-weight: bold;
  font-size: 14px;
  color: #333;
}

.clip-bucket {
  font-family: monospace;
  font-size: 12px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clip-date {
  font-size: 12px;
  color: #777;
}

.download-button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 8px;
  font-size: 13px;
  align-self: flex-end;
}

.download-button:hover {
  background-color: #45a049;
}

/* For unavailable downloads */
.clip-item:has(.download-button:contains("Unavailable")) .download-button {
  background-color: #ccc;
  cursor: not-allowed;
}

/* For fallback when :has selector is not supported in all browsers */
.download-button.unavailable {
  background-color: #ccc;
  cursor: not-allowed;
}

.history-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.history-page h1 {
  margin-bottom: 20px;
  color: #333;
}

.loading, .error, .no-jobs {
  text-align: center;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
}

.error {
  color: #d32f2f;
  background-color: #ffebee;
}

.jobs-table-container {
  overflow-x: auto;
}

.jobs-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.jobs-table th,
.jobs-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.jobs-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #555;
}

.job-row {
  transition: background-color 0.2s;
  cursor: pointer;
}

.job-row:hover {
  background-color: #f5f9ff;
}

.job-id {
  font-family: monospace;
  font-size: 0.9rem;
}

.expand-button {
  background: none;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #555;
  background-color: #f0f0f0;
  transition: all 0.2s;
}

.expand-button:hover {
  background-color: #e0e0e0;
  color: #333;
}

.status {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: capitalize;
}

.status-success {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.status-processing {
  background-color: #e3f2fd;
  color: #1565c0;
}

.status-failed {
  background-color: #ffebee;
  color: #c62828;
}

.status-pending {
  background-color: #f5f5f5;
  color: #616161;
}

.actions {
  white-space: nowrap;
}

.view-button {
  display: inline-block;
  padding: 6px 12px;
  background-color: #3498db;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.85rem;
  transition: background-color 0.2s;
}

.view-button:hover {
  background-color: #2980b9;
}

.expanded-details td {
  padding: 0;
}

.job-details-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  background-color: #f9f9f9;
  gap: 20px;
}

.clip-details-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

@media (max-width: 768px) {
  .clip-details-container {
    grid-template-columns: 1fr;
  }
}

.clip-section {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.clip-section h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.clip-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.clip-item {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1.5fr auto;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  border: 1px solid #eee;
}

.clip-item:hover {
  background-color: #f0f7ff;
}

.clip-name {
  font-weight: 500;
}

.clip-bucket {
  font-family: monospace;
  font-size: 0.85rem;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clip-date {
  font-size: 0.85rem;
  color: #666;
}

.download-button {
  padding: 5px 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
}

.download-button:hover {
  background-color: #388e3c;
}

.download-button.unavailable {
  background-color: #ccc;
  cursor: not-allowed;
}

@media (max-width: 992px) {
  .clip-item {
    grid-template-columns: 1fr 1fr;
  }
  
  .clip-bucket {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/History.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,wCAAwC;EACxC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* src/pages/History.css */\n.history-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\nh1 {\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 28px;\n}\n\n.refresh-button {\n  background-color: #4a90e2;\n  color: white;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.refresh-button:hover {\n  background-color: #357bd8;\n}\n\n.refresh-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.loading {\n  text-align: center;\n  margin: 40px 0;\n  font-size: 18px;\n  color: #666;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.no-jobs {\n  text-align: center;\n  margin: 40px 0;\n  font-size: 18px;\n  color: #666;\n}\n\n/* Table styles */\n.jobs-table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.jobs-table {\n  width: 100%;\n  border-collapse: collapse;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  background-color: white;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.jobs-table th,\n.jobs-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.jobs-table th {\n  background-color: #f5f7fa;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.jobs-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.jobs-table tbody tr:hover {\n  background-color: #f9f9f9;\n}\n\n.job-id {\n  font-family: monospace;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.status {\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.status-completed {\n  color: #28a745;\n}\n\n.status-pending {\n  color: #ffc107;\n}\n\n.status-failed {\n  color: #dc3545;\n}\n\n.status-processing {\n  color: #17a2b8;\n}\n\n.actions {\n  text-align: center;\n}\n\n.view-button {\n  display: inline-block;\n  background-color: #4a90e2;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  text-decoration: none;\n  font-size: 13px;\n  transition: background-color 0.2s;\n}\n\n.view-button:hover {\n  background-color: #357bd8;\n  text-decoration: none;\n  color: white;\n}\n\n/* Expand/collapse button */\n.expand-button {\n  background: none;\n  border: 1px solid #ddd;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  line-height: 22px;\n  text-align: center;\n  font-size: 16px;\n  cursor: pointer;\n  color: #555;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.expand-button:hover {\n  background-color: #f0f0f0;\n}\n\n/* Expanded details row */\n.expanded-details {\n  background-color: #f9f9f9;\n}\n\n.expanded-details td {\n  padding: 20px;\n}\n\n/* Clip details container and sections */\n.clip-details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.clip-section {\n  margin-bottom: 10px;\n}\n\n.clip-section h3 {\n  margin-top: 0;\n  margin-bottom: 12px;\n  color: #333;\n  font-size: 16px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 8px;\n}\n\n/* Clip list */\n.clip-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 12px;\n}\n\n.clip-item {\n  background-color: white;\n  border: 1px solid #eee;\n  border-radius: 6px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transition: transform 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n}\n\n.clip-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.clip-name {\n  font-weight: bold;\n  font-size: 14px;\n  color: #333;\n}\n\n.clip-bucket {\n  font-family: monospace;\n  font-size: 12px;\n  color: #666;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.clip-date {\n  font-size: 12px;\n  color: #777;\n}\n\n.download-button {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 8px;\n  font-size: 13px;\n  align-self: flex-end;\n}\n\n.download-button:hover {\n  background-color: #45a049;\n}\n\n/* For unavailable downloads */\n.clip-item:has(.download-button:contains(\"Unavailable\")) .download-button {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* For fallback when :has selector is not supported in all browsers */\n.download-button.unavailable {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.history-page {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.history-page h1 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.loading, .error, .no-jobs {\n  text-align: center;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  margin: 20px 0;\n}\n\n.error {\n  color: #d32f2f;\n  background-color: #ffebee;\n}\n\n.jobs-table-container {\n  overflow-x: auto;\n}\n\n.jobs-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.jobs-table th,\n.jobs-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.jobs-table th {\n  background-color: #f5f7fa;\n  font-weight: 600;\n  color: #555;\n}\n\n.job-row {\n  transition: background-color 0.2s;\n  cursor: pointer;\n}\n\n.job-row:hover {\n  background-color: #f5f9ff;\n}\n\n.job-id {\n  font-family: monospace;\n  font-size: 0.9rem;\n}\n\n.expand-button {\n  background: none;\n  border: none;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #555;\n  background-color: #f0f0f0;\n  transition: all 0.2s;\n}\n\n.expand-button:hover {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.status {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.status-success {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-processing {\n  background-color: #e3f2fd;\n  color: #1565c0;\n}\n\n.status-failed {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.status-pending {\n  background-color: #f5f5f5;\n  color: #616161;\n}\n\n.actions {\n  white-space: nowrap;\n}\n\n.view-button {\n  display: inline-block;\n  padding: 6px 12px;\n  background-color: #3498db;\n  color: white;\n  text-decoration: none;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  transition: background-color 0.2s;\n}\n\n.view-button:hover {\n  background-color: #2980b9;\n}\n\n.expanded-details td {\n  padding: 0;\n}\n\n.job-details-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 20px;\n  background-color: #f9f9f9;\n  gap: 20px;\n}\n\n.clip-details-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n@media (max-width: 768px) {\n  .clip-details-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n.clip-section {\n  background-color: #fff;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.clip-section h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-size: 1.1rem;\n  color: #333;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 8px;\n}\n\n.clip-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.clip-item {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr 1.5fr auto;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border: 1px solid #eee;\n}\n\n.clip-item:hover {\n  background-color: #f0f7ff;\n}\n\n.clip-name {\n  font-weight: 500;\n}\n\n.clip-bucket {\n  font-family: monospace;\n  font-size: 0.85rem;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.clip-date {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.download-button {\n  padding: 5px 10px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.download-button:hover {\n  background-color: #388e3c;\n}\n\n.download-button.unavailable {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n@media (max-width: 992px) {\n  .clip-item {\n    grid-template-columns: 1fr 1fr;\n  }\n  \n  .clip-bucket {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
